module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page",
    attrs: {
      "id": "PAGE-SWF"
    }
  }, [_c('div', {
    staticClass: "total-time"
  }, [_vm._v(_vm._s(_vm.formatDuration(_vm.current_time) + '/' + _vm.formatDuration(_vm.total_time)))]), _vm._v(" "), _c('div', {
    staticClass: "ope-list"
  }, [_c('div', {
    staticClass: "icon-template_add",
    attrs: {
      "title": "添加"
    },
    on: {
      "click": function($event) {
        return _vm.handleAdd()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "icon-template_copy",
    attrs: {
      "title": "复制"
    },
    on: {
      "click": function($event) {
        return _vm.hanldePause()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "icon-home_template_save",
    staticStyle: {
      "font-size": "26px"
    },
    attrs: {
      "title": "另存为模版"
    },
    on: {
      "click": function($event) {
        return _vm.hanldeSave()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "icon-template_delete",
    attrs: {
      "title": "删除"
    },
    on: {
      "click": function($event) {
        return _vm.handleDel()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "page-list"
  }, [_c('div', {
    attrs: {
      "id": "bottom"
    }
  }, [_c('draggable', {
    on: {
      "end": _vm.onDragEnd
    },
    model: {
      value: (_vm.page_list),
      callback: function($$v) {
        _vm.page_list = $$v
      },
      expression: "page_list"
    }
  }, [_c('transition-group', _vm._l((_vm.page_list), function(item, index) {
    return _c('div', {
      key: item.id || 'page_' + index,
      staticClass: "page-item",
      on: {
        "click": function($event) {
          return _vm.handlePageChange(index)
        }
      }
    }, [_c('div', {
      class: {
        active: item.active
      },
      on: {
        "click": function($event) {
          return _vm.handlePageChange(index)
        }
      }
    }, [(item.cover == '') ? _c('span', [_vm._v(_vm._s(index + 1))]) : _vm._e(), _vm._v(" "), (item.cover != '') ? _c('p', {
      staticStyle: {
        "position": "absolute",
        "right": "0",
        "top": "0",
        "background": "rgba(0,0,0,0.4)",
        "width": "24px",
        "height": "15px",
        "line-height": "15px",
        "font-size": "10px",
        "text-align": "center",
        "color": "#fff"
      }
    }, [_vm._v(_vm._s(index + 1))]) : _vm._e(), _vm._v(" "), (item.cover != '') ? _c('img', {
      attrs: {
        "src": item.cover
      }
    }) : _vm._e()])])
  }), 0)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box"
  })]), _vm._v(" "), _c('div', {
    staticClass: "play-btn"
  }, [(_vm.play_status) ? _c('el-button', {
    staticClass: "start",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.handlePlay()
      }
    }
  }, [_c('span', [_c('span', {
    staticClass: "path1"
  }), _c('span', {
    staticClass: "path2"
  })])]) : _vm._e(), _vm._v(" "), (!_vm.play_status) ? _c('el-button', {
    staticClass: "stop",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.handlePause()
      }
    }
  }, [_c('span', [_c('span', {
    staticClass: "path1"
  }), _c('span', {
    staticClass: "path2"
  }), _c('span', {
    staticClass: "path3"
  })])]) : _vm._e()], 1), _vm._v(" "), (_vm.platform == 'qt') ? _c('psocket', {
    attrs: {
      "attributes": _vm.attributes,
      "flashvars": _vm.flashvars
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f90d506","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Page/Page.vue
// module id = 388
// module chunks = 0